module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAOpJREFUSIndVTsWwiAQnMXcS3Ki0JiXyoCVTxs9UeLBZC0UjWgIRONTp4Ldx8yyHwB+HeQWq0XRvErGRId6s9MPAqZUGuD6VQEAYEG5Xu9at89CzhToSkmy3JCFBHDlEKPCTEDW59CVkuLYnzYmOrBAO3TjXoEzCWTAK8kS0ElHksAlMurzx2LyGkQL6EpJXSmZKhCswV0kt4K3KQLfk6KxiJ4D17LdN8vOyLx9DjybCZ0PCvhz4CJfbvf5EGkXf1xkH+5xm0zA/6li8ZkUsUBLFjVZbkxZjGOy/NR8bUNTKk3M83HsN/htfAKPzVge1WHwtwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/icon1.png
// module id = TiXU
// module chunks = 1